import React from 'react';
import { useWorldStore } from '../state/worldStore';

// adminChrome — what every World tool panel shares about FITTING ON THE SCREEN
// (2026-11-01).
//
// Khari: "the admin columns often overlap and I cannot close them unless I
// stretch my screen beyond the UI." Each panel was pinned 200px down (or at the
// top-left) with no height limit, so a long list ran off the bottom of the
// window, and the left-hand ones lay over the ⚙ menu — the only way to close a
// tool. So:
//   adminPanel(style)  caps a panel's height to the window it is in (down to
//                      the bottom bar, and on the left down to the ⚙), and
//                      scrolls inside it instead of off the screen
//   <AdminClose />     a ✕ in the panel's own corner, pinned there while it
//                      scrolls: closing a tool never needs the ⚙ again
// The ⚙ menu itself rises above any panel while it is open (AdminPanel).
const IS_TOUCH = typeof window !== 'undefined' && (('ontouchstart' in window) || navigator.maxTouchPoints > 0);

/** The ⚙'s offset from the bottom of the screen (AdminPanel `wrap`): above the now-playing bar or the joystick. */
export const GEAR_BOTTOM = `calc(max(16px, env(safe-area-inset-bottom)) + ${IS_TOUCH ? 158 : 62}px)`;
// What a panel leaves free at the bottom: the bar (or joystick), and on the left the ⚙ above it.
const BAR_CLEAR = `(max(16px, env(safe-area-inset-bottom)) + ${IS_TOUCH ? 158 : 62}px)`;
const GEAR_CLEAR = `(max(16px, env(safe-area-inset-bottom)) + ${IS_TOUCH ? 158 : 62}px + 56px)`;

// maxHeight measures the CONTENT box: a panel's own padding and border (~26px)
// come on top, so they are allowed for here (caught 2026-11-01: a panel capped
// "to the ⚙" still lay 16px over it).
const PAD = '32px';

/** A tool panel's style, capped to the window and scrolling inside itself. */
export function adminPanel(base) {
  const onLeft = base.left != null && base.right == null;
  const clear = onLeft ? GEAR_CLEAR : BAR_CLEAR;
  if (base.bottom != null && base.top == null) {
    // Pinned to the bottom: on the left that is where the ⚙ is, so it sits above it.
    const bottom = onLeft ? `calc${GEAR_CLEAR}` : base.bottom;
    return { ...base, bottom, maxHeight: `calc(100dvh - ${onLeft ? GEAR_CLEAR : `(${base.bottom})`} - 16px - ${PAD})`, overflowY: 'auto', overscrollBehavior: 'contain' };
  }
  const top = base.top ?? '16px';
  return { ...base, maxHeight: `calc(100dvh - (${top}) - ${clear} - ${PAD})`, overflowY: 'auto', overscrollBehavior: 'contain' };
}

/** ✕ in the panel's top-right corner, there however far the panel is scrolled. */
export function AdminClose() {
  return (
    <div style={{ position: 'sticky', top: 0, height: 0, zIndex: 3, display: 'flex', justifyContent: 'flex-end', pointerEvents: 'none' }}>
      <button
        type="button"
        aria-label="Close this tool"
        title="Close this tool"
        onClick={() => useWorldStore.setState({ adminTool: null })}
        style={{
          pointerEvents: 'auto', width: 24, height: 24, marginTop: -6, marginRight: -6, padding: 0, borderRadius: 999,
          cursor: 'pointer', font: '700 12px/22px system-ui, sans-serif', textAlign: 'center',
          background: 'rgba(16,10,6,0.92)', color: '#ffe9c4', border: '1px solid rgba(255,178,94,0.5)',
        }}
      >
        ✕
      </button>
    </div>
  );
}
